import { Button, ButtonProps, FlexProps, IconInfoCircle } from '@cmpsr/components';

type SeeDetailsButtonProps = FlexProps &
  ButtonProps & {
    onClick: () => void;
  };

export default function SeeDetailsButton({ onClick, ...props }: SeeDetailsButtonProps) {
  return (
    <Button onClick={onClick} variant="link-secondary" size="s" leadingIcon={<IconInfoCircle />} {...props}>
      See details
    </Button>
  );
}
